package app.components

import app.api.ProjectReleasesPaginatedApi
import app.api.ProjectStepApi
import app.model.Deployable
import app.model.EcsDeploymentStep
import app.model.UpdateLambdaStep
import app.model.UploadS3Step
import app.plugin.Routing
import dev.fritz2.core.*
import kotlinx.browser.window

fun RenderContext.releaseCreationForm(
    projectId: String,
    showCreateReleaseMenu: Store<Boolean>,
    projectStepApi: ProjectStepApi,
    latestDeployables: List<Deployable>,
    projectReleasePaginatedApi: ProjectReleasesPaginatedApi,
) {
    val inputValue = storeOf("")
    val deployables = storeOf(mapOf<String, String>())

    div("w-full flex flex-col mb-4 gap-4 dark:text-white") {
        input(
            "border w-full rounded-lg p-2 h-14 dark:bg-gray-700 dark:border-gray-600 " +
                    "dark:text-white dark:placeholder-gray-400"
        ) {
            placeholder("Version")
            value(inputValue.data)
            changes.values() handledBy inputValue.update
        }
        projectStepApi.handler(projectId)
        projectStepApi.data.render { steps ->
            val stepsWithDeployables = steps.filter {
                it is UpdateLambdaStep || it is UploadS3Step || it is EcsDeploymentStep
            }
            // Build complete map first, because rendering overrides the store, this the only way
            val updatedDeployables =
                stepsWithDeployables.flatMap { stepWithDeployable ->
                    when (stepWithDeployable) {
                        is UpdateLambdaStep -> listOf(stepWithDeployable.deployableName)
                        is UploadS3Step -> listOf(stepWithDeployable.deployableName)
                        is EcsDeploymentStep -> stepWithDeployable.containerDefinitions.map { it.deployableName }
                        else -> emptyList()
                    }.map { deployableName ->
                        val latestVersion =
                            latestDeployables.find { it.name == deployableName }
                                ?.version
                                ?.toString()
                                ?: run {
                                    val errorMessage = "No deployable found with name: $deployableName"
                                    window.alert(errorMessage)
                                    throw IllegalStateException(errorMessage)
                                }
                        deployableName to latestVersion
                    }
                }.toMap()
            deployables.update(updatedDeployables)
            deployables.data.render { deployablesData ->
                deployablesData.forEach { entry ->
                    div("w-full flex mb-4 gap-4 dark:text-white") {
                        div("w-full m-auto pl-2 dark:text-gray-200") {
                            +entry.key
                        }
                        input("border w-full rounded-lg p-2 h-14 dark:bg-gray-700 " +
                                "dark:border-gray-600 dark:text-white dark:placeholder-gray-400") {
                            value(entry.value)
                            changes.values() handledBy {
                                deployables.update(
                                    deployablesData + mapOf(
                                        entry.key to it
                                    )
                                )
                            }
                        }
                    }
                }
            }
            inputValue.data.render {
                buttonText(
                    text = "Submit",
                    isDisabled = it == "",
                    onClick = {
                        projectReleasePaginatedApi.newProjectRelease(
                            Routing.ProjectReleases.New.Body(
                                projectId = projectId.toInt(),
                                version = inputValue.current,
                                deployables = deployables.current

                            )
                        )
                        inputValue.update("")
                        showCreateReleaseMenu.update(false)
                        deployables.update(mapOf())
                    }
                )
            }
        }
    }
}